// extracted by mini-css-extract-plugin
module.exports = {"container":"BlogLayout_container__35Nm1","title":"BlogLayout_title__2O4J2"};